import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { ERouteLinks } from 'models/route';
import BoxLink from 'components/atoms/BoxLink';
import { StyledTitle } from 'pages/DashboardPage/styles';

const DashboardBeforeYouApply = () => (
  <Grid container rowGap="20px">
    <Grid item xs={12}>
      <StyledTitle variant="h4">Before you apply</StyledTitle>
    </Grid>
    <Grid item xs={12} mb="20px">
      <Typography variant="body1">
        Make sure you read <Link to={ERouteLinks.Dashboard}>the guidance notes</Link> in full.
        For further information, please use the links below.
      </Typography>
    </Grid>
    <Grid item container xs={12} columnSpacing="20px" rowGap="20px">
      <Grid item xs={12} md={6} lg={4}>
        <BoxLink link={ERouteLinks.Dashboard} textLink="Key licence information" />
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
        <BoxLink link={ERouteLinks.Dashboard} textLink="Licensing fees" />
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
        <BoxLink link={ERouteLinks.Dashboard} textLink="Age restrictions" />
      </Grid>
    </Grid>
  </Grid>
);

export { DashboardBeforeYouApply };
